<template>
  <div style="height: 100%">
    <transition-group name="splashscreen">
      <div
        v-if="showSplash && !bootLoader"
        key="splashscreen"
        class="splashscreen"
        :style="{
          backgroundImage: `url('/images/front/splashscreen.png?${splashT}')`
        }"
      />
      <template v-else-if="!showSplash">
        <virtual-mobile-layout
          v-if="isVirtual && isMobile"
          key="virtual-mobile-layout"
        />
        <virtual-desktop-layout
          v-else-if="isVirtual"
          key="virtual-desktop-layout"
        />
        <modern-layout v-else-if="isModern" key="modern-layout" />
        <classic-layout v-else key="classic-layout" />
        <notifications-alert
          v-if="showNotifications"
          key="notifications-alert"
        />
      </template>
    </transition-group>
    <settings-modal />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import NotificationsAlert from './components/views/notifications-alert'
import ClassicLayout from './layouts/Classic'
import VirtualDesktopLayout from './layouts/VirtualDesktop'
import VirtualMobileLayout from './layouts/VirtualMobile'
import ModernLayout from './layouts/Modern'
import navigateMixin from './mixins/navigate'
import scrollMixin from './mixins/scroll'
import SettingsModal from './components/settings/modal'
import './cookie_consent_init'

const speakers = () =>
  import(/* webpackChunkName: "speakers" */ './components/speakers')
const speakerDetail = () =>
  import(/* webpackChunkName: "speaker" */ './components/speaker-detail')
const partners = () =>
  import(/* webpackChunkName: "partners" */ './components/partners')
const sessions = () =>
  import(/* webpackChunkName: "sessions" */ './components/sessions')
const modernProgramme = () =>
  import(/* webpackChunkName: "modern-programme" */ './components/modern/Programme')
const modernNews = () =>
  import(/* webpackChunkName: "modern-news" */ './components/modern/News')
const modernProfile = () =>
  import(/* webpackChunkName: "modern-profile" */ './components/modern/Profile')
const modernContentPage = () =>
  import(/* webpackChunkName: "modern-content" */ './components/modern/ContentPage')
const modernNode = () =>
  import(/* webpackChunkName: "modern-node" */ './components/modern/Node')
const modernPartners = () =>
  import(/* webpackChunkName: "modern-partners" */ './components/modern/Partners')
const modernQuestions = () =>
  import(/* webpackChunkName: "modern-questions" */ './components/modern/Questions')
const modernQuestionsForm = () =>
  import(/* webpackChunkName: "modern-questions" */ './components/modern/QuestionsForm')
const modernPosters = () =>
  import(/* webpackChunkName: "modern-posters" */ './components/modern/Posters')
const modernFeedback = () =>
  import(/* webpackChunkName: "modern-feedback" */ './components/modern/Feedback')
const modernFeedbackForm = () =>
  import(/* webpackChunkName: "modern-feedback" */ './components/modern/FeedbackForm')
const modernNetworking = () =>
  import(/* webpackChunkName: "modern-networking" */ './components/modern/Networking')
const modernNetworkingChat = () =>
  import(/* webpackChunkName: "modern-networking" */ './components/modern/NetworkingChat')
const modernNetworkingRegister = () =>
  import(/* webpackChunkName: "modern-networking" */ './components/modern/NetworkingRegister')
const modernVoting = () =>
  import(/* webpackChunkName: "modern-voting" */ './components/modern/Voting')
const modernQuiz = () =>
  import(/* webpackChunkName: "modern-quiz" */ './components/modern/Quiz')
const modernTop = () =>
  import(/* webpackChunkName: "modern-games" */ './components/modern/Top')
const modernTeam = () =>
  import(/* webpackChunkName: "modern-games" */ './components/modern/Team')
const modernGallery = () =>
  import(/* webpackChunkName: "modern-gallery" */ './components/modern/Gallery')
const modernChat = () =>
  import(/* webpackChunkName: "modern-chat" */ './components/modern/Chat')
const modernMeetings = () =>
  import(/* webpackChunkName: "modern-services" */ './components/modern/Meetings')
const modernActivities = () =>
  import(/* webpackChunkName: "modern-services" */ './components/modern/Activities')
const modernSpeakers = () =>
  import(/* webpackChunkName: "modern-speakers" */ './components/modern/Speakers')
const modernNetworkingProfile = () =>
  import(/* webpackChunkName: "modern-networking" */ './components/modern/NetworkingProfile')
const node = () => import(/* webpackChunkName: "node" */ './components/node')
const questions = () =>
  import(/* webpackChunkName: "questions" */ './components/questions')
const questionsForm = () =>
  import(/* webpackChunkName: "questions" */ './components/questions-form')
const content_pages = () =>
  import(/* webpackChunkName: "content_pages" */ './components/content_pages')
const feedback = () =>
  import(/* webpackChunkName: "feedback" */ './components/feedback')
const feedbackForm = () =>
  import(/* webpackChunkName: "feedback" */ './components/feedback-form')
const voting = () =>
  import(/* webpackChunkName: "voting" */ './components/voting')
const survey = () =>
  import(/* webpackChunkName: "survey" */ './components/survey')
const user_gallery = () =>
  import(/* webpackChunkName: "user_gallery" */ './components/user_gallery')
const photobooth = () =>
  import(/* webpackChunkName: "photobooth" */ './components/photobooth')
const iframe = () =>
  import(/* webpackChunkName: "iframe" */ './components/iframe')
const messages = () =>
  import(/* webpackChunkName: "messages" */ './components/messages')
const activities = () =>
  import(/* webpackChunkName: "activities" */ './components/activities')
const my_profile = () =>
  import(/* webpackChunkName: "my_profile" */ './components/my_profile')
const top = () =>
  import(/* webpackChunkName: "my_profile" */ './components/top')
const team = () => import(/* webpackChunkName: "team" */ './components/team')
const networking = {
  main: () =>
    import(/* webpackChunkName: "networking" */ './components/networking/main'),
  register: () =>
    import(
      /* webpackChunkName: "networking" */ './components/networking/register'
    ),
  profile: () =>
    import(
      /* webpackChunkName: "networking" */ './components/networking/profile'
    ),
  chat: () =>
    import(/* webpackChunkName: "networking" */ './components/networking/chat'),
}
const chat = () => import(/* webpackChunkName: "chat" */ './components/chat')
const quiz = () => import(/* webpackChunkName: "quiz" */ './components/quiz')
const instagram_gallery = () =>
  import(
    /* webpackChunkName: "instagram_gallery" */ './components/instagram_gallery'
  )
const meetings = () =>
  import(/* webpackChunkName: "meetings" */ './components/meetings')
const access_denied = () =>
  import(/* webpackChunkName: "access_denied" */ './components/access_denied')

export default {
  mixins: [navigateMixin, scrollMixin],

  components: {
    ClassicLayout,
    VirtualDesktopLayout,
    VirtualMobileLayout,
    ModernLayout,
    NotificationsAlert,
    SettingsModal,
  },

  data() {
    let appLastUpdated = EasyEvent.lastUpdated

    return {
      appLastUpdated,
      showSplash: true,
      // modern design renders its loader in index.blade.php (#ee-boot), before the bundle loads
      bootLoader: !!document.getElementById('ee-boot'),
      splashT: EasyEvent.splashT
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      fullMenu: state => state.common.menu,
      showRoomsSelect: state => state.common.virtual.showRoomsSelect,
      defaultRoom: state => state.common.virtual.multipleRooms.defaultRoom,
      deviceId: state => state.common.deviceId,
    }),

    ...mapGetters('common', ['showNotifications', 'rootMenu', 'isVirtual', 'layout']),

    isModern() {
      return !!(this.layout && this.layout.modernDesign)
    },

    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },

  created() {
    const authPromise = this.$store.dispatch('auth/getVisitor')
    const commonPromise = this.$store.dispatch('common/getData')
    // the programme loads in parallel; the modern boot loader waits for it too (at most a few seconds),
    // so the home screen appears complete instead of filling in after the loader
    const sessionsPromise = this.$store.dispatch('sessions/getSessions').catch(() => {})
    // a programme cached from the last visit is already in the store – no need to wait
    const programmeOrTimeout = this.$store.state.sessions.loaded
      ? Promise.resolve()
      : Promise.race([sessionsPromise, new Promise(resolve => setTimeout(resolve, 4000))])

    Promise.all([authPromise, commonPromise]).then(() => (this.bootLoader ? programmeOrTimeout : null)).then(() => {
      this.createRoutes()
      // a leftover #/login in the URL means nothing to a signed-in visitor
      if (this.user && this.$route.path === '/login') {
        const redirect = this.$store.state.auth.redirectUrl
        this.$router.replace(redirect && redirect !== '/login' ? redirect : '/').catch(() => {})
      }
      this.checkVirtualDefaultRoom()
      this.showSplash = false
      if (window.eeBootDone) window.eeBootDone()

      this.fetchMessages()
      if (this.user) {
        this.fetchNetworkingNotifications()
      }
    })

    this.listen()
    this.resyncOnResume()

    setInterval(() => {
      this.checkAppUpdate()
    }, 60000)

    cc.runWithLocale()
  },

  methods: {
    ...mapActions(['fetchMessages', 'fetchNetworkingNotifications']),

    ...mapMutations(['addNewMessage', 'removeMessage', 'addNetworkingMessage', 'removeNetworkingMessagesByIds']),

    ...mapMutations('chat', {
      addNewChatMessage: 'addMessage',
      removeChatMessage: 'removeMessage',
    }),

    ...mapMutations('common', ['saveSettings', 'changeSmileysVisibility']),

    // a sleeping phone or a dropped connection misses socket events: reload the unread counts (and let open
    // networking screens reload, 'ee:resync') when the app comes back or the socket reconnects
    resyncOnResume() {
      const resync = () => {
        this.fetchMessages()
        if (this.user) this.fetchNetworkingNotifications()
        window.dispatchEvent(new Event('ee:resync'))
      }
      let hiddenAt = null
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          hiddenAt = Date.now()
        } else if (hiddenAt && Date.now() - hiddenAt > 5000) {
          hiddenAt = null
          resync()
        }
      })
      let connectedOnce = socket.connected
      socket.on('connect', () => {
        if (connectedOnce) resync()
        connectedOnce = true
      })
    },

    listen() {
      socket.on(EasyEvent.channel + ':App\\Events\\NewMessage', data => {
        let msg = data.message
        if (
          msg.badge_types.length === 0 ||
          (this.user && msg.badge_types.includes(this.user.badge_type))
        ) {
          this.addNewMessage(msg)
        }
      })
      socket.on(EasyEvent.channel + ':App\\Events\\MessageDeleted', data => {
        this.removeMessage(data.message)
      })
      socket.on(
        EasyEvent.channel + ':App\\Events\\NewNetworkingMessage',
        data => {
          if (this.user) {
            let msg = data.message

            if (Number(msg.receiver_id) === Number(this.user.id)) {
              this.addNetworkingMessage(msg)
            }
          }
        }
      )
      socket.on(
        `${EasyEvent.channel}:App\\Events\\NetworkingMessagesRead`,
        data => {
          if (this.user && Number(data.receiver_id) === Number(this.user.id)) {
            this.removeNetworkingMessagesByIds(data.ids)
          }
        }
      )
      socket.on(
        `${EasyEvent.channel}:App\\Events\\NewChatMessage`,
        ({ message }) => {
          this.addNewChatMessage(message)
        }
      )
      socket.on(
        `${EasyEvent.channel}:App\\Events\\ChatMessageDeleted`,
        ({ message }) => {
          this.removeChatMessage(message)
        }
      )
      socket.on(
        EasyEvent.channel + ':App\\Events\\QuizQuestionStateChanged',
        ({ question }) => {
          if (question.active) {
            const menu = this.fullMenu.find(
              item => item.module === 'quiz' && !item.config
            )
            if (menu) {
              this.navigateTo(menu)
            }
          }
        }
      )
      socket.on(
        `${EasyEvent.channel}:App\\Events\\SettingsChanged`,
        ({ settings }) => {
          this.saveSettings(settings)
        }
      )
      socket.on(
        `${EasyEvent.channel}:App\\Events\\LogoutVisitorFromDevice`,
        ({ visitor_id, device_id }) => {
          if (
            this.user &&
            this.user.id === visitor_id &&
            device_id !== this.deviceId
          ) {
            this.logout('another_device')
          }
        }
      )
      socket.on(
        `${EasyEvent.channel}:App\\Events\\ChangeSmileysVisibility`,
        data => {
          this.changeSmileysVisibility(data)
        }
      )
    },

    checkAppUpdate() {
      axios
        .get('/updated')
        .then(response => {
          if (response.data > this.appLastUpdated) {
            location.reload()
          }
        })
        .catch(() => {})
    },

    createRoutes() {
      const routes = [
        {
          path: '*',
          components: {
            // modern design: an unknown address says so instead of an empty screen
            ...(this.isModern && !this.isVirtual
              ? { default: () => import(/* webpackChunkName: "modern-not-found" */ './components/modern/NotFound') }
              : {}),
            viewer: () =>
              import(
                /* webpackChunkName "stream" */ './components/video-stream'
              ),
          },
        },
        {
          path: '/room-:roomId?/',
          alias: '/',
          component:
            this.isVirtual && this.rootMenu.length
              ? eval(this.rootMenu[0].module)
              : this.isModern
              ? () =>
                  import(/* webpackChunkName: "modern-home" */ './components/modern/Home')
              : () =>
                  import(/* webpackChunkName: "home" */ './components/home'),
          props: {
            login:
              this.isVirtual && this.rootMenu.length
                ? !!this.rootMenu[0].login_required
                : false,
            module_key:
              this.isVirtual && this.rootMenu.length
                ? this.rootMenu[0].module
                : 'home',
            config:
              this.isVirtual && this.rootMenu.length
                ? this.rootMenu[0].config
                : null,
            slug:
              this.isVirtual && this.rootMenu.length
                ? this.rootMenu[0].slug
                : null,
          },
        },
        {
          path: '/showrooms',
          name: 'showrooms',
          components: {
            viewer: () =>
              import(
                /* webpackChunkName: "showrooms" */ './components/showrooms'
              ),
          },
        },
        {
          path: '/showroom/:slug',
          name: 'showroom',
          components: {
            default: () =>
              import(
                /* webpackChunkName: "showrooms" */ './components/showroom-chat'
              ),
            viewer: () =>
              import(
                /* webpackChunkName: "showrooms" */ './components/showroom-viewer'
              ),
          },
        },
      ]

      this.fullMenu.forEach(item => {
        if (item.module === 'external_link') return

        routes.push({
          path: `/room-:roomId?/${item.slug}`,
          alias: `/${item.slug}`,
          component: !item.enabled
            ? access_denied
            : item.module === 'networking'
            ? (this.isModern ? modernNetworking : networking.main)
            : this.isModern && ['sessions', 'my_schedule'].includes(item.module)
            ? modernProgramme
            : this.isModern && item.module === 'messages'
            ? modernNews
            : this.isModern && item.module === 'my_profile'
            ? modernProfile
            : this.isModern && item.module === 'node'
            ? modernNode
            : this.isModern && item.module === 'partners'
            ? modernPartners
            : this.isModern && item.module === 'feedback'
            ? modernFeedback
            : this.isModern && item.module === 'survey'
            ? modernPosters
            : this.isModern && item.module === 'questions'
            ? modernQuestions
            : this.isModern && item.module === 'content_pages'
            ? modernContentPage
            : this.isModern && item.module === 'speakers'
            ? modernSpeakers
            : this.isModern && item.module === 'voting'
            ? modernVoting
            : this.isModern && item.module === 'quiz'
            ? modernQuiz
            : this.isModern && item.module === 'top'
            ? modernTop
            : this.isModern && item.module === 'team'
            ? modernTeam
            : this.isModern && item.module === 'user_gallery'
            ? modernGallery
            : this.isModern && item.module === 'chat'
            ? modernChat
            : this.isModern && item.module === 'meetings'
            ? modernMeetings
            : this.isModern && item.module === 'activities'
            ? modernActivities
            : item.module === 'my_schedule'
            ? sessions
            : eval(item.module),
          name: item.name,
          module: item.module,
          props: {
            parent: item.parent,
            login: !!item.login_required,
            module_key: item.module,
            config: item.config,
            slug: item.slug,
          },
        })

        if (item.module === 'speakers') {
          routes.push({
            path: `/room-:roomId?/${item.slug}/detail/:id`,
            alias: `/${item.slug}/detail/:id`,
            name: 'speaker-detail',
            component: !item.enabled ? access_denied : speakerDetail,
            props: {
              parent: `/${item.slug}`,
              login: !!item.login_required,
            },
          })
          routes.push({
            path: `/room-:roomId?/${item.slug}/detail/:id/:parent`,
            alias: `/${item.slug}/detail/:id/:parent`,
            name: 'speaker-detail-parent',
            component: !item.enabled ? access_denied : speakerDetail,
            props: {
              login: !!item.login_required,
            },
          })
        } else if (item.module === 'feedback') {
          routes.push({
            path: `/room-:roomId?/${item.slug}/form/:id`,
            alias: `/${item.slug}/form/:id`,
            component: !item.enabled ? access_denied : this.isModern ? modernFeedbackForm : feedbackForm,
            name: 'feedback-form',
            props: {
              parent: `/${item.slug}`,
              login: !!item.login_required,
            },
          })
        } else if (item.module === 'questions') {
          routes.push({
            path: `/room-:roomId?/${item.slug}/form/:id`,
            alias: `/${item.slug}/form/:id`,
            component: !item.enabled ? access_denied : this.isModern ? modernQuestionsForm : questionsForm,
            name: 'questions-form',
            props: {
              parent: `/${item.slug}`,
              login: !!item.login_required,
            },
          })
          routes.push({
            path: `/room-:roomId?/${item.slug}/form/:id/:parent`,
            alias: `/${item.slug}/form/:id/:parent`,
            component: !item.enabled ? access_denied : this.isModern ? modernQuestionsForm : questionsForm,
            name: 'questions-form-parent',
            props: {
              login: !!item.login_required,
            },
          })
        } else if (item.module === 'networking') {
          routes.push({
            path: `/room-:roomId?/${item.slug}/profile/:id`,
            alias: `/${item.slug}/profile/:id`,
            component: !item.enabled ? access_denied : this.isModern ? modernNetworkingProfile : networking.profile,
            name: 'networking-profile',
            props: {
              parent: `/${item.slug}`,
              login: !!item.login_required,
            },
          })
          routes.push({
            path: `/room-:roomId?/${item.slug}/register/:action?`,
            alias: `/${item.slug}/register/:action?`,
            component: !item.enabled ? access_denied : this.isModern ? modernNetworkingRegister : networking.register,
            name: 'networking-register',
            props: {
              parent: `/${item.slug}`,
              login: !!item.login_required,
            },
          })
          routes.push({
            path: `/room-:roomId?/${item.slug}/chat/:id`,
            alias: `/${item.slug}/chat/:id`,
            component: !item.enabled ? access_denied : this.isModern ? modernNetworkingChat : networking.chat,
            name: 'networking-chat',
            props: {
              parent: `/${item.slug}`,
              login: !!item.login_required,
            },
          })
        } else if (item.module === 'my_profile') {
          routes.push({
            path: `/room-:roomId?/${item.slug}/top/:type?`,
            alias: `/${item.slug}/top/:type?`,
            component: !item.enabled ? access_denied : this.isModern ? modernTop : top,
            name: 'profile_top',
            props: {
              parent: `/${item.slug}`,
              login: !!item.login_required,
            },
          })
        }
      })

      if (this.isModern) {
        // participant profile, reachable from the avatar even without a my_profile menu item
        routes.push({ path: '/profile', component: modernProfile })
        // "More" tab (as in the prototype): every root menu item as a colored tile
        routes.push({
          path: '/more',
          component: () => import(/* webpackChunkName: "modern-more" */ './components/modern/More'),
        })

        // living stylebook of the modern design (tokens + components)
        routes.push({
          path: '/design',
          component: () =>
            import(/* webpackChunkName: "modern-design" */ './components/modern/Design'),
        })
      }

      this.$router.addRoutes(routes)
    },

    checkVirtualDefaultRoom() {
      if (this.isVirtual && this.showRoomsSelect && this.defaultRoom) {
        this.navigateTo(`/room-${this.defaultRoom}`)
      }
    },
  },
}
</script>
